<template>
  <form>
    <p v-if="error" class="error">{{ error }}</p>
    <div class="form-group row">
      <input
        v-model="username"
        type="text"
        id="username"
        autocomplete="username"
        class="form-control"
        :placeholder="$t('email')"
        autofocus
        @keyup.enter="login()"
      />
    </div>
    <div class="form-group row">
      <input
        v-model="password"
        type="password"
        id="password"
        class="form-control"
        name="password"
        autocomplete="current-password"
        :placeholder="$t('password')"
        required
        @keyup.enter="login()"
      />
    </div>
    <div class="form-group">
      <b-row class="my-2 text-center">
        <b-col md="12">
          <pw-button id="login" :spinner="loading" className="success" @accepted="login()">
            <span class="icon">
              <i class="fa fa-sign-in-alt"></i>
              {{ $t("login") }}
            </span>
          </pw-button>
        </b-col>
      </b-row>
    </div>
  </form>
</template>

<script>
import AuthService from "@/services/AuthService";
import AzureAuthService from "@/services/AzureAuthService";

export default {
  name: "LoginForm",
  props: {
    redirectRoute: { type: String, default: "home" }, // Route name
    redirectUrl: { type: String, default: null } // Route URL - takes precedence over route name if defined!
  },
  data() {
    return {
      username: null,
      password: null,
      error: null,
      loading: false
    };
  },
  mounted() {
    if (this.$route.query.hasOwnProperty("token") && this.$route.query.hasOwnProperty("key")) {
      let token = this.$route.query.token;
      token = token.replace(/\s+/g, "+");
      let key = this.$route.query.key;
      key = key.replace(/\s+/g, "+");

      this.username = this.CryptoJS.AES.decrypt(token, "xg7qXT<@T'#E6Rr,").toString(this.CryptoJS.enc.Utf8);
      this.password = this.CryptoJS.AES.decrypt(key, "xg7qXT<@T'#E6Rr,").toString(this.CryptoJS.enc.Utf8);

      this.login();
    }
  },
  methods: {
    login() {
      this.loading = true;
      AuthService.login(this.username, this.password, this.$route.query["fortnox-authorization-code"])
        .then((response) => {
          if (response.status === 200) {
            this.error = null;

            if (this.redirectUrl) {
              this.$router.push(this.redirectUrl);
            } else {
              this.$router.push({ name: this.redirectRoute });
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            if (error.response.status === 400) {
              this.error = this.$t("errors.incorrectUsernameOrPassword");
            } else {
              this.error = this.$t("errors.generic");
            }
          } else {
            this.error = this.$t("errors.generic");
          }

          this.loading = false
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
form {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 50px auto auto auto;
}

.error {
  color: red;
}
</style>
